<div class="field-container" [formGroup]="group">
  <label class="field-label">Grading Period Date Range</label>

  <div class="range-picker field-row">
    <mat-form-field class="full-width-field">
      <mat-date-range-input [rangePicker]="picker">
        <input
          matStartDate
          placeholder="From Date"
          required
          formControlName="fromDate"
          (dateChange)="onStartChange($event)"
          [required]="config.required"
        />
        <input
          matEndDate
          placeholder="To Date"
          required
          formControlName="toDate"
          (dateChange)="onEndChange($event)"
          [required]="config.required"
        />
      </mat-date-range-input>

      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>

  <!-- Invalid Date Messages -->
  <mat-error
    class="error-container"
    *ngIf="group.controls.fromDate.hasError('matStartDateInvalid')"
    >Invalid start date</mat-error
  >
  <mat-error
    class="error-container"
    *ngIf="group.controls.toDate.hasError('matEndDateInvalid')"
    >Invalid end date</mat-error
  >

  <!-- Required Date Messages -->
  <mat-error
    class="error-container"
    *ngIf="
      group.controls.fromDate.errors?.required &&
      group.controls.fromDate.touched
    "
    >From Date Required</mat-error
  >
  <mat-error
    class="error-container"
    *ngIf="
      group.controls.toDate.errors?.required && group.controls.toDate.touched
    "
    >To Date Required</mat-error
  >
  <span class="error-padding"></span>
</div>
